import { inject } from '@angular/core';
import { InitStore } from '@app2/store/init/init.store';

export class LayoutBase {
  private initStore = inject(InitStore);

  public isUserAdult = this.initStore.isUserAdult;
}
